<div class="container padding-top">
  <div class="row margin-bottom">
    <div class="col-sm-offset-2 col-sm-4">
      <md-card class="stat-block text-center">
        <h3><b>Total Clicks</b></h3>
        <h1>{{ totalClicks }}</h1>
      </md-card>
    </div>
    <div class="col-sm-4">
      <md-card class="stat-block text-center">
        <h3><b>Total Short URLS</b></h3>
        <h1>{{ totalShortUrls }}</h1>
      </md-card>
    </div>
    <!--<div class="col-sm-4">-->
    <!--<md-card class="stat-block text-center">-->
    <!--<h3><b>Full URL</b></h3>-->
    <!--<h1>{{ shortUrl?.shortLinkStats?.clickData[0]?.long_url }}</h1>-->
    <!--</md-card>-->
    <!--</div>-->
  </div>

  <md-card class="margin-bottom margin-top">
    <div class="row">
      <div class="col-md-12">
        <canvas baseChart
                width="400"
                height="200"
                [data]="doughnutChartData"
                [labels]="doughnutChartLabels"
                [chartType]="doughnutChartType"
                [options]="lineChartOptions"
                (chartHover)="chartHovered($event)"
                (chartClick)="chartClicked($event)"></canvas>
      </div>
    </div>
  </md-card>

  <md-card class="margin-bottom margin-top">
    <div class="row">
      <div class="col-md-12">
        <div style="display: block;">
          <canvas baseChart
                  width="400"
                  height="200"
                  [datasets]="lineChartData"
                  [labels]="lineChartLabels"
                  [options]="lineChartOptions"
                  [legend]="lineChartLegend"
                  [chartType]="lineChartType"
                  (chartHover)="chartHovered($event)"
                  (chartClick)="chartClicked($event)"></canvas>
        </div>
      </div>
    </div>
  </md-card>

  <md-card class="margin-bottom margin-top">
    <div class="row">
      <div class="col-md-6">
        <input pInputTextarea
               class="full-width"
               [(ngModel)]="longUrl">
        <button class="btn btn-primary sm-margin-top sm-margin-bottom"
                style="float: right;"
                color="primary"
                (click)="generateShortUrl()">Generate Short URL</button>
      </div>
      <div class="col-md-6 short-url">
        <h2>{{newShortUrl}}</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="ui-widget-header"
             style="padding:4px 10px;border-bottom: 0 none">
          <i class="fa fa-search"
             style="margin:4px 4px 0 0"></i>
          <input #gb
                 type="text"
                 pInputText
                 placeholder="Search"
                 style="width: 250px !important;">
        </div>
        <p-dataTable [value]="statsArray"
                     sortField="longUrl"
                     class="text-center"
                     selectionMode="single"
                     [rows]="20"
                     [responsive]="true"
                     [paginator]="true"
                     [globalFilter]="gb"
                     [immutable]="false"
                     #dt>
          <p-column field="numClicks"
                    header="# of Clicks"
                    [sortable]="true"></p-column>
          <p-column field="longUrl"
                    header="Long URL"
                    [sortable]="true"></p-column>
          <p-column field="shortUrl"
                    header="Short URL"
                    [sortable]="true"></p-column>
          <p-column field="urlId"
                    header="">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <button class="btn btn-default"
                      (click)="goToLinkGraph(car[col.field])">Stats</button>
            </ng-template>
          </p-column>
        </p-dataTable>
      </div>
    </div>
  </md-card>

</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/puggl-stats/puggl-stats.component.html